import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=4e606de8&scoped=true&"
import script from "./Affiliates.vue?vue&type=script&lang=js&"
export * from "./Affiliates.vue?vue&type=script&lang=js&"
import style0 from "./Affiliates.vue?vue&type=style&index=0&id=4e606de8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e606de8",
  null
  
)

export default component.exports